/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState, useRef } from 'react'
import NavbarNotAuth from '../../../userNotAuth/components/navbarNotAuth'
import { NavbarTopAdmin, NavbarBottomAdmin } from '../../../admin/components'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import DivBottom from '../../../userNotAuth/components/divBottom'
import AddImg from '../../../admin/components/addImg'
import { RotatingLines } from "react-loader-spinner"
import ReactQuill from 'react-quill-new'

function AddFornitore() {
    const navigate = useNavigate()
    const emailUser = localStorage.getItem('email')
    const [formData, setFormData] = useState({
        altro: '',
        cachet: '',
        descrizione: '',
        email: emailUser,
        nome: '',
        fb: '',
        città: '',
        idUser: localStorage.getItem('id'),
        regione: '',
        telefono: '',
        url: '',
        video: ''
    })
    const [msgForm, setMsgForm] = useState({ tipologia: '', telefono: '', descrizione: '', emailValidate: '', descrizione: '' })
    const [foto, setFoto] = useState([])
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null })//barra del loader dopo submit 
    const [validate, setValidate] = useState({ videoStateMessage: null })
    const [fornitori, setFornitori] = useState([])
    const [fornitore, setFornitore] = useState()

    const numFoto = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------
    const details = { display: 'grid', gridTemplateColumns: '.20fr 1fr', gap: '5px' }

    const descrizione = useRef()
    const telefono = useRef()
    const altro = useRef()// altro genere in options
    const divNuovoFornitore = useRef()
    const divDettagli = useRef()

    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {
                if (ETarget.size > 100000000) {
                    setValidate({ ...validate, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setValidate({ ...validate, videoStateMessage: 'Attendere...upload video in corso' })

                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setValidate({ ...validate, videoStateMessage: '*** Video troppo lungo (max 5 min)' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'
                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        // rinomino il video con un nome random
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setValidate({ ...validate, videoStateMessage: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData2.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setValidate({ ...validate, videoStateMessage: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setValidate({ ...validate, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setValidate({ ...validate, videoStateMessage: '*** Problemi con la connessione...riprova ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setValidate({ ...validate, videoStateMessage: null })
    }
    function handleChange(e) {
        const vb = altro.current.style
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        setMsgForm({}); setMsgProgress({ failed: null })
        // descrizione.current.style.border = '1px solid black'; telefono.current.style.border = '1px solid black'

        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsgForm({ telefono: '*** Campo numerico ***' }) }
        }
        if (name === 'genere' && value === 'Altro') { vb.display = 'block' } else
            if (name === 'genere' && value !== 'Altro' && altro.current.style.display === 'block') {
                altro.current.style.display = 'none'
                document.getElementById('altro').value = ""
            }
        if (name === 'altro') { setFormData({ ...formData, genere: inputValue }); return }
    }
    function handleDescrizione(e) {
        setFormData({ ...formData, descrizione: e })
        setMsgForm({ descrizione: formData.descrizione.length })
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        setMsgProgress({ string: 'Caricamento in corso...', failed: null })
        descrizione.current.style.border = '1px solid black'
        altro.current.className = 'border-none'
        if (formData.genere === "Altro" && formData.altro === "") {
            altro.current.className = 'border border-danger'; window.scrollTo(0, 400); return
        }
        if (formData.descrizione.length < 30 || formData.descrizione.length > 2000) {
            setMsgForm({ descrizione: 'Almeno 30 caratteri, max 2000' }); window.scrollTo(0, 600)
            descrizione.current.style.border = '1px solid red'; return
        }
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData.email) || formData.email === '') {
            setMsgForm({ emailValidate: 'Email non valida' }); window.scrollTo(0, 580); return
        }
        if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
            setMsgForm({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 500); return
        }
        //ACCETTAZIONE EVENTO
        const object = { ...formData, foto: foto }
        setTimeout(() => {
            try {
                axios.post(`/createFornitore`, object).then(res => {
                    if (res.data === 'success') {
                        setMsgProgress({ string: null })
                        // document.body.style.overflow = "hidden"
                        divNuovoFornitore.current.style.display = 'block'
                        axios.get('getFornitori').then(res2 => {
                            setFornitori(res2.data)
                        })
                    }
                })
            } catch (err) { setMsgProgress({ failed: '*** Problemi con il server...riprova ***', string: null }); console.error(err); return }
        }, 2000)
    }
    useEffect(() => {
        for (let h = 1; h < numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            document.getElementById('upload-photo' + (h)).disabled = true// disabilito tutti gli input foto tranne il primo
        }
        window.scrollTo(0, 0)
    }, [])

    // useEffect(() => { console.log('fornitore', fornitore) }, [fornitore])

    return (<>
        {localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}

        <div className='container' style={{ marginBottom: '3rem', marginTop: '6rem' }}>
            <p onClick={() => { navigate(-1) }} style={{ cursor: 'pointer', fontSize: 'xx-large' }}>
                ◀
            </p><hr />

            <h2 className='mt-3'>Aggiungi un allestimento</h2>

            <p style={{ margin: '1rem 0 3rem 0' }}><i>Aggiungi un allestimento per poter essere contattato dagli organizzatori
                degli eventi.</i>
            </p>
            <form onSubmit={handleSubmit}>

                <div> {/* ------------- NOME ----------------- */}
                    <label htmlFor='nome'>Nome Cognome </label>
                    <input className="form-control fw-bold"
                        name="nome"
                        maxLength={25}
                        onChange={handleChange}
                        type="text" />
                </div>

                <div> {/* ------------- NOME AZIENDA ----------------- */}
                    <label htmlFor='azienda' className='mt-5'>Nome Azienda</label>
                    <input className="form-control fw-bold"
                        name="azienda"
                        maxLength={25}
                        onChange={handleChange}
                        type="text" />
                </div>

                <div> {/* ------------- CITTA' ----------------- */}
                    <label htmlFor='città' className='mt-2'>Città *</label>
                    <input className="form-control fw-bold"
                        name="città" required
                        maxLength={25}
                        onChange={handleChange}
                        type="text" />
                </div>
                <div> {/* ------------- REGIONE ----------------- */}
                    <label htmlFor='regione' className='mt-2'>Regione *</label>
                    <input className="form-control fw-bold"
                        name="regione" required
                        maxLength={25}
                        onChange={handleChange}
                        type="text" />
                </div>

                <div>{/* ------------- TIPOLOGIA ----------------- */}
                    <label htmlFor='tipologia' className='mt-4'>Tipologia *</label>
                    <select className="form-select mt-1 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                        name="genere" required
                        onChange={handleChange} >
                        <option value=''></option>
                        <option value="Agenzia di artisti">Agenzia di artisti</option>
                        <option value="Allestimenti floreali">Allestimenti floreali</option>
                        <option value="Event Planner/Organizer">Event Planner/Organizer</option>
                        <option value="Fornitore di tende e tessuti">Fornitore di tende e tessuti</option>
                        <option value="Impiantista elettrico">Impiantista elettrico</option>
                        <option value="Montaggio palchi/passerelle">Montaggio palchi/passerelle</option>
                        <option value="Noleggio arredi/tavoli/sedie">Noleggio arredi/tavoli/sedie</option>
                        <option value="Noleggio gazebo/tensostrutture">Noleggio gazebo/tensostrutture</option>
                        <option value="Noleggio gonfiabili">Noleggio gonfiabili</option>
                        <option value="Noleggio giochi per bambini">Noleggio giochi per bambini</option>
                        <option value="Pista stradale per bambini">Pista stradale per bambini</option>
                        <option value="Scenografi e decoratori">Scenografi e decoratori</option>
                        <option value="Security Service">Security Service</option>
                        <option value="Service Amplificazione/Microfoni">Service Amplificazione/Microfoni</option>
                        <option value="Service Audio/Video/Luci">Service Audio/Video/Luci</option>
                        <option value="Servizio Catering">Servizio Catering</option>
                        <option value="Tappeto elastico per bambini">Tappeto elastico per bambini</option>
                        <option value="Altro">Altro</option>
                    </select>
                    <div ref={altro} style={{ display: 'none', margin: '6px 0 0 1em', padding: '5px' }}>
                        <label>Inserisci il servizio che fornisci (non la descrizione ma il genere) *</label>
                        <input className="form-control fw-bold mt-1" id="altro"
                            name="altro"
                            maxLength={50}
                            onChange={handleChange}
                            placeholder='es. Scenografie con proiettori'
                            type="text" />
                    </div>
                    {msgForm.tipologia && <p style={{ color: 'red' }}><i>{msgForm.tipologia}</i></p>}
                </div>

                <div>{/* ------------- DESCRIZIONE ----------------- */}
                    <h4 style={{ marginTop: '3rem' }}>Descrivi il tuo servizio nell'evento *</h4>
                    <p><i>Ad esempio qualche dettaglio importante della tua fornitura o azienda</i></p>
                    <div ref={descrizione}>
                        <ReactQuill
                            value={formData.descrizione}
                            theme="snow"
                            onChange={handleDescrizione}
                            placeholder="Es: dal 1 al 4 novembre si svolgerà a Spoleto il grande Show dell' open jazz band..."
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                    ['link'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                                ]
                            }}
                        />
                    </div>
                    {msgForm.descrizione && <p style={{ color: 'red', fontSize: 'small' }}><i>{msgForm.descrizione}</i></p>}
                </div>

                <div>{/* ------------- TELEFONO ----------------- */}
                    <label htmlFor='telefono' className='mt-3'>Telefono </label>
                    <input className='form-control fw-bold' ref={telefono}
                        name='telefono'
                        maxLength={20}
                        onChange={handleChange}
                        type='text' />
                    {msgForm.telefono && <p style={{ color: 'red' }}><i>{msgForm.telefono}</i></p>}
                </div>

                <div>{/* -------------------------- Email -------------------- */}
                    <label htmlFor='form-control fw-bold'>Email *</label>
                    <input className="form-control" id="email"
                        defaultValue={formData.email}
                        name='email'
                        required
                        onChange={handleChange}
                        placeholder='es. zonaeventiinfo@gmail.com'
                        type='text' />
                    {msgForm.emailValidate && <p style={{ color: 'red' }}>{msgForm.emailValidate}</p>}
                </div>

                <div>{/* ------------- FOTO ----------------- */}
                    <AddImg numero={[0, 1, 2]} folder={''} invioFoto={(e) => { setFoto(e) }} />
                    <br /><br />
                </div>

                <div>{/* ------------- VIDEO ----------------- */}
                    <h4 style={{ marginTop: '3rem' }}>AGGIUNGI VIDEO</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData.video &&
                            <div>
                                <div style={{ marginTop: '-28px' }}>
                                    <button style={{ marginLeft: '9.5rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>

                                {/* ------------- preview del video proveniente da MYSQL saved in AWS ------------ */}
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                    style={{ width: '198px', height: '130px', borderRadius: '5px' }} controls />
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>

                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {validate.videoStateMessage &&
                        <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{validate.videoStateMessage}</i></p>
                    }
                </div>

                <div>{/* -------------LINK ----------------- */}
                    <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                    {/* ---------------------- Sito web -------------------- */}
                    <div style={{ marginLeft: '1rem' }}>
                        <label htmlFor='email' className='mt-1'>URL sito web</label>
                        <input className="form-control"
                            name="url"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.zona-eventi.it/'
                            type="text" />
                        <label htmlFor='email' className='mt-3'>URL Facebook</label>
                        <input className="form-control"
                            name="fb"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.facebook.com/'
                            type="text" />

                        <label htmlFor='email' className='mt-3'>URL Instagram</label>
                        <input className="form-control"
                            name="instagram"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.instagram.com/'
                            type="text" />
                    </div>
                </div>

                <div>{/* ------------- CACHET ----------------- */}
                    <label htmlFor='cachet' className='mt-4'>Cachet </label>
                    <input className="form-control fw-bold"
                        name="cachet"
                        maxLength={6}
                        onChange={handleChange}
                        placeholder='€'
                        type="text" />
                </div>

                <p className='mt-4 fs-6'><i>* campi obbligatori</i></p>

                {msgProgress.string &&
                    <h5 className='mt-3'>
                        <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                        <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                    </h5>
                }

                {msgProgress.failed && <p style={{ color: 'red', marginTop: '1em' }}>{msgProgress.failed}</p>}
                <hr />

                <div className='mt-3'>
                    <button type='button' className='btn btn-secondary'
                        onClick={() => { navigate(-1) }}> Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '4rem' }}>Avanti</button>
                </div>
            </form>
        </div>

        {/* --------------------- BANNER FORNITORE DOPO LA CREAZIONE ---------------------- */}
        <div ref={divNuovoFornitore} style={{
            backgroundColor: 'whitesmoke', border: '2px solid lightgrey', width: '100%', height: '100%', position: 'fixed',
            top: '0', left: '0', right: '0', padding: '3px', display: 'none', zIndex: '1'
        }}>
            <div style={{ padding: '1.5em' }}>
                <span onClick={() => {
                    divNuovoFornitore.current.style.display = 'none'
                    document.body.style.overflow = "scroll"
                    navigate('/fornitori', { replace: true })
                }}
                    style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>◁
                </span>
                <h2 style={{ display: 'inline', fontWeight: '600', fontFamily: 'sans-serif', textAlign: 'center' }}>
                    Fornitore aggiunto con successo
                </h2>
            </div><hr />

            <div className='bodyPadding' style={{ overflowY: 'scroll', height: '78%', scrollBehavior: 'smooth' }}>
                {fornitori &&
                    fornitori.reverse().filter(item => (item.accettazione === 'true'))
                        .map(elem => {
                            let arrImg
                            if (elem.img) arrImg = elem.img.split(',')
                            return (
                                <div key={elem.id} className='mt-2 p-1'>
                                    {elem.img &&
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${arrImg[0]}`} alt=''
                                            style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%' }} />
                                    }
                                    {/* ----------- NOME AZIENDA -------------------- */}
                                    {elem.gruppo &&
                                        <p className='fw-semibold fs-4 mt-2'>{elem.gruppo.toUpperCase()}</p>
                                    }
                                    {/* -------------- NOME E COGNOME ---------------- */}
                                    {elem.nome &&
                                        <p style={{ fontFamily: 'Times New Roman' }} className='mt-1'>
                                            {elem.nome} {elem.cognome}
                                        </p>
                                    }
                                    {/* ----------------- GENERE ---------------------------- */}
                                    <p className='fs-5 text-success'>
                                        <i>{elem.genere}</i>
                                    </p>
                                    {/* ------------------ CITTA' ---------------------- */}
                                    {elem.città &&
                                        <p className='mt-2'>{elem.città}</p>
                                    }
                                    {/* ------------------  TELEFONO + EMAIL ------------------- */}
                                    {elem.telefono &&
                                        <p className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                            <p>
                                                <img src={require('../../../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25em' alt='' />
                                            </p>
                                            <p>{elem.telefono}</p>
                                            <p>
                                                <img src={require('../../../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width='25em' alt='' />
                                            </p>
                                            <p>{elem.emailUser}</p>
                                        </p>
                                    }
                                    <button className='btn btn-primary mt-1' onClick={() => {
                                        setFornitore(elem)
                                        divDettagli.current.style.top = '0'
                                    }}
                                        style={{ fontSize: 'small', fontWeight: '600' }}>
                                        Dettagli
                                    </button>
                                    <hr style={{ height: '2px', backgroundColor: 'black' }} />
                                </div>
                            )
                        })
                }
            </div>
        </div>

        {/* --------- BANNER DEI DETTAGLI  ---------- */}
        <div className='visualDettagli' ref={divDettagli}>
            {fornitore !== undefined &&
                <div className='mt-3 mb-5'>
                    <div style={{ cursor: 'pointer', float: 'right' }} onClick={() => {
                        divDettagli.current.style.top = '120%'; document.body.style.overflow = 'scroll';
                        if (fornitore.video) {
                            const lp = document.getElementById('videoPreview')
                            lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                        } setFornitore({})
                    }}>
                        <img src={require('../../../userNotAuth/image/icons8-chiudi-macos-32.png')} width={40} alt='' />
                    </div><br />
                    <div className='bodyPadding mt-3 fs-6'>
                        {fornitore.img &&
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${fornitore.img.split(',')[0]}`} alt=''
                                style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%' }} />
                        }
                        {/* ----------------- NOME AZIENDA ------------------ */}
                        {fornitore.gruppo &&
                            <div className='fs-3 text-success fw-semibold mt-3'>{fornitore.gruppo.toUpperCase()}</div>
                        }
                        {/* ------------------------- CITTA' E REGIONE ------------------------ */}
                        {fornitore.regione &&
                            <div className='fs-5 text-success'>{fornitore.regione}
                                {fornitore.città && <span> - {fornitore.città}</span>}
                            </div>
                        }
                        {/* -------------------- NOME E COGNOME ------------------- */}
                        {fornitore.nome &&
                            <div className='mt-3' style={details}><div>NOME: </div><div>{fornitore.nome} {fornitore.cognome}</div></div>
                        }
                        {/* ----------------------- GENERE ------------------------------ */}
                        <div style={details}><div>TIPO:</div> <div>{fornitore.genere}</div> </div>
                        {fornitore.cachet &&
                            <div style={details}><div>Cachet:</div><div> € {fornitore.cachet}</div>
                            </div>
                        }
                        {/* --------------------- TELEFONO ---------------------- */}
                        {fornitore.telefono &&
                            <div style={details}>
                                <div><img src={require('../../../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25em' alt='' /></div>
                                <div>{fornitore.telefono}</div>
                            </div>
                        }
                        {/* -------------------------- EMAIL --------------------- */}
                        {fornitore.emailUser &&
                            <div style={details}>
                                <div><img src={require('../../../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width='25em' alt='' /></div>
                                <div>{fornitore.emailUser}</div>
                            </div>
                        }
                        {/* ---------------------------- DESCRIZIONE --------------------- */}
                        <p style={{ border: '2px solid lightblue', fontWeight: '500', backgroundColor: '#fffcfc', padding: '20px 10px', margin: '2em 0' }}>
                            <p className='text-center fs-5 text-secondary'><i>{fornitore.genere}</i></p>
                            <p className='fs-5 d-inline' id='descr'></p>
                        </p>
                        {/* ----------------------------- LINK ---------------------- */}
                        <div style={{ border: '1px solid lightgrey', borderRadius: '15px', padding: '15px 10px', marginTop: '1em' }}>
                            <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                            {fornitore.url &&
                                <div className='btn btn-warning'>
                                    <a href={fornitore.url} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>Sito web</a>
                                </div>
                            }
                            {fornitore.fb &&
                                <a className='ms-2' href={fornitore.fb} target='_blank'>
                                    <img src={require('../../../userNotAuth/image/icons8-fb-48.png')} alt='' />
                                </a>
                            }
                            {fornitore.youtube &&
                                <a className='ms-2' href={fornitore.youtube} target='_blank'>
                                    <img src={require('../../../userNotAuth/image/icons8-instagram-48.png')} alt='' />
                                </a>
                            }
                            {!fornitore.url && !fornitore.fb && !fornitore.youtube && <span><i>nessun link presente</i></span>}
                        </div>
                        {/* ---------------------- FOTO ----------------------- */}
                        {fornitore.img &&
                            <div className='row mt-3'>
                                {fornitore.img.split(',').map((img, index) => (
                                    <div key={index} className="card mt-3"
                                        style={{
                                            width: '20rem', height: '100%',
                                            padding: '0px',
                                            margin: '0 auto',
                                            border: '3px solid gainsboro',
                                        }}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${img}`} style={{ objectFit: 'cover' }} width='100%' alt='' />
                                    </div>
                                ))}
                            </div>
                        }
                        {/* ------------------------ VIDEO ------------------------ */}
                        {fornitore.video &&
                            <div className='text-center mt-5'>
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${fornitore.video}`} id={'videoPreview'}
                                    style={{ width: '99%', maxHeight: '200px', borderRadius: '5px' }} controls />
                            </div>
                        }
                    </div>
                    <button className='mt-5 btn btn-secondary' onClick={() => {
                        divDettagli.current.style.top = '120%'; document.body.style.overflow = 'scroll'
                        if (fornitore.video) {
                            const lp = document.getElementById('videoPreview')
                            lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                        } setFornitore({})
                    }}>Indietro</button>
                </div>
            }
        </div>
        <DivBottom />
    </>)
}
export default AddFornitore